import { SimpleInventory } from "../Inventories/SimpleInventory";

export enum TaskRemindersState {
    NeedsToBeSent = "NeedsToBeSent",
    PeekLock = "PeekLock",
    Sent = "Sent"
}

export enum TaskManagementLinkedItemType {
    Inventory = "Inventory",
    Survey = "Survey",
    CustomerRequest = "CustomerRequest"
}

export enum TaskStatus {
    New = "New",
    Active = "Active",
    Closed = "Closed"
}

export enum TaskFilterType {
    Status = "status",
    UserId = "assignedUserId",
    DeadlineDateBefore = "deadlineDateBefore",
    DeadlineDateAfter = "deadlineDateAfter",
    Search = "search"
}

export enum TaskSortableColumns {
    Title,
    State, 
    DueDate
}

export interface TaskManagementState {
    tasks: {[taskId: string] : Task},
    filteredAndSortedTaskIds: string[],
    selectedTaskIds: { [id: string]: string },
    openTaskId: string | null,
    showErrorMessage: boolean,
    dataLoaded: boolean,
    taskFilters: { [filterType in TaskFilterType] : string[] }
    searchBarInput: string;
    teamMembers: TaskAssignedUser[];
    surveyList: TaskManagementDataCollectionRequest[];
    inventoryIdToInventoryNamesMap: { [inventoryId: string]: SimpleInventory },
    filesTable: { [fileId: string]: string },
    sortSettings: SortOptions
}

interface SortOptions {
    activeSortColumn: TaskSortableColumns,
    sortAscending: boolean
}

interface TaskCoreData {
    title: string,
    description: string,
    deadlineDate: string | null,
    assignedUserId: string | null,
    assignedByUserId: string | null,
    status: TaskStatus,
    linkedItems: TaskManagementLinkedItem[],
    weeklyReminderState: TaskRemindersState,
    dailyReminderState: TaskRemindersState,
    weeklyPeekLockTimeout: string | null,
    dailyPeekLockTimeout: string | null,
    attachedFileIds: string[]
}

export interface TaskManagementApiRequest extends TaskCoreData {
    taskId: string | null,
    sendAssignmentReminder: boolean
}

export interface Task extends TaskCoreData {
    taskId: string,
    teamOwnerId: string;
}

export interface TaskManagementLinkedItem {
    itemType: TaskManagementLinkedItemType,
    itemId: string,
    secondaryItemId?: string
}

export interface TaskAssignedUser {
    userId: string,
    firstName: string,
    lastName: string,
    emailId: string,
}

export interface TaskManagementViewLinkedInventoriesContext {
    inventoryIdsToFilter: string[];
    viewProducts: boolean;
}


export interface TaskManagementApiResponse {
    tasks: { [taskId: string]: Task },
    linkableDataCollectionRequests: TaskManagementDataCollectionRequest[],
    taskAssignedUsers: TaskAssignedUser[],
    inventoryIdToInventoryNamesMap: { [inventoryId: string] : SimpleInventory},
    fileIdsToFileNameMap: { [fileId: string]: string }
}

export interface TaskManagementDataCollectionRequest {
    requestId: string,
    surveyName: string,
    fromname: string, 
    sendToEmail: string,
    surveyType: string,
    state: number
}